<template>
  <el-container class="indexhome is-vertical">
     <div class="index_tishi" v-if="tishi">
       <span >{{tishi}} </span>
    </div>
    <el-main>
      <!-- 登录 -->
      <div class="login_form" v-if="isshow">

        <!-- <div class="form_list"> -->
        <el-form style="width:100%" :model="ruleForm" :rules="signValidate"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <h3 class="logintitle">Sign In</h3>
          <h4 class="tips">Enter your phone number or email to sign in.</h4>
          <!-- <p class="itemtitle" style="margin-top:25px;">Phone Number</p> -->
          <el-tabs v-model="activeName" :stretch="true" class="login_tabs"  @tab-click="handleClickpe">
            <el-tab-pane label="Phone Number" name="first">
              <div class="phone_form" style="margin-top:15px">
                <el-select v-model="ruleForm.areaCode" collapse-tags @change="changeCode">
                  <div class="el-input_search">
                    <img src="../assets/search.svg" /><input type="text" placeholder="Search Area Code" class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
                  </div>
                  <el-option v-for="item in areaCodeData"
                    :key="item.id"
                    :label="'+' + item.country_code+' '+item.title "
                    :value="item.id">+{{item.country_code}} {{item.title}}</el-option>
                </el-select>
                <el-form-item prop="phone" class="loginPhone">
                  <el-input style="width:99.5%" oninput="value=value.replace(/\D/gi,'')" :class="changeLoginFlag == 1?'phone':'errorPass'" class="phone" type="text" v-model="ruleForm.phone" autocomplete="off" :maxlength="max" placeholder="Please enter your phone number"></el-input>
                </el-form-item>
              </div>
              <p class="itemtitlelogin" style="margin-top:50px">
                <span :class="{ 'active': currentTab === 'password' }" @click="currentTab = 'password'">Password</span>
                <span :class="{ 'active': currentTab === 'verification' }" @click="currentTab = 'verification'">Verification Code</span>
              </p>
              <div v-if="currentTab == 'password'" style="width:100%">
                <el-form-item prop="password" class="password">
                <el-input :class="changeFlag == 1?'pass':'errorPass'" :type="ruleForm.pwdType" v-model="ruleForm.password" autocomplete="off" placeholder="Please enter your password"></el-input>
               <img :src="ruleForm.seen?openeye:nopeneye" class="eye" alt="" @click="changeType(ruleForm.seen)">
              </el-form-item>
              <div class="rebox">
                  <el-checkbox v-model="checked" class="rendme">Remember me</el-checkbox>
                  <span
                  class="huo"
                  @click="forgetPass"
                  >Forgot Password?</span>
              </div>
              </div>
              <div v-if="currentTab == 'verification'" class="verificationbox">
                <el-input v-model="ruleForm.yzmcode" placeholder="Enter verification code" style="width:72%"></el-input>
                <el-button type="primary" @click="logincountDown()" class="borderBtn" v-if="maxTotaltime==setTime||setTime==0">Send</el-button>
                <el-button class="borderBtn" v-else>Resend Code (<span>{{setTime}}</span>s)</el-button>
              </div>
              <div class="login_bottondiv">
                <el-button type="primary" @click="submitForm()">Log in</el-button>
                <el-button class="createaccount_button" @click="toRegister()">Create an account</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Email" name="second">
              <div class="email_form" style="margin-top:15px">
                <el-form-item prop="email" class="loginEmail">
                <el-input oninput="value=value.replace(/[^a-zA-Z0-9._%+-@]/gi,'')"  :class="changeLoginFlag == 1?'email':'errorPass'" type="email" v-model="ruleForm.email" autocomplete="off" placeholder="Enter email address"></el-input>
              </el-form-item>
              </div>
              <p class="itemtitlelogin" style="margin-top:50px">
                <span :class="{ 'active': emailcurrentTab === 'emailpassword' }" @click="emailcurrentTab = 'emailpassword'">Password</span>
                <span :class="{ 'active': emailcurrentTab === 'emailverification' }" @click="emailcurrentTab = 'emailverification'">Verification Code</span>
              </p>
              <div v-if="emailcurrentTab == 'emailpassword'">
                <el-form-item prop="password" class="password">
                <el-input :class="changeFlag == 1?'email':'errorPass'" :type="ruleForm.pwdType" v-model="ruleForm.password" autocomplete="off" placeholder="Please enter your password"></el-input>
               <img :src="ruleForm.seen?openeye:nopeneye" class="eye" alt="" @click="emailchangeType(ruleForm.seen)">
              </el-form-item>
              <div class="rebox">
                  <el-checkbox v-model="checked" class="rendme">Remember me</el-checkbox>
                  <span
                  class="huo"
                  @click="forgetPass"
                  >Forgot password?</span>
              </div>
              </div>
              <div v-if="emailcurrentTab == 'emailverification'" class="verificationbox">
                <el-input v-model="ruleForm.yzmcode" placeholder="Enter verification code" style="width:72%"></el-input>
                <el-button type="primary" @click="logincountDown()" class="borderBtn" v-if="maxTotaltime==setTime||setTime==0">Send</el-button>
                <el-button class="borderBtn" v-else>Resend Code (<span>{{setTime}}</span>s)</el-button>
              </div>
              <div class="login_bottondiv">
                <el-button type="primary" @click="submitForm()">Log in</el-button>
                <el-button class="createaccount_button" @click="toRegister()">Create an account</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <!-- 忘记密码 -->
      <div class="forgot_form" v-else-if="isforget">
        <p @click="back()" style="margin-bottom:10px;" class="backbox"><i class="icon el-icon-arrow-left"></i>Back</p>
        <div class="forgetpassgebox">
        <el-form :model="forgetForm" :rules="signValidate" ref="forgetForm" label-width="100px" class="demo-forgetForm" style="width:100%">
          <h3 class="forgettitle">Forget Password</h3>
          <p>
            <span
            >Select the retrieval method</span>
          </p>
          <!-- <p style="margin-top:22px;margin-bottom: 16px" class="itemtitle">Phone Number</p> -->
          <el-select class="selectphonetext" v-model="methodsvalue" placeholder="Select the retrieval method" style="margin:40px 0 40px 0">
            <el-option
              v-for="item in selectmethods"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div v-if="methodsvalue === 'Phone Number'" class="phone_form">
            <el-select v-model="forgetForm.areaCode" collapse-tags @change="changeCodeforget">
              <div class="el-input_search">
                <img src="../assets/search.svg" /><input type="text" placeholder="Search Area Code" class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
              </div>
              <el-option v-for="item in areaCodeData"
                :key="item.id"
                :label="'+' + item.country_code+' '+item.title "
                :value="item.id">+{{item.country_code}} {{item.title}}</el-option>
            </el-select>
            <el-form-item prop="phone">
              <el-input style="width:100%" oninput="value=value.replace(/\D/gi,'')" :class="changeLoginFlag == 1?'phone':'errorPass'" type="text" v-model="forgetForm.phone" autocomplete="off" :maxlength="maxforget" placeholder="Enter phone number"></el-input>
            </el-form-item>
          </div>
          <div v-else>
            <el-input v-model="forgetForm.email" :class="changeAgainFlag == 1?'':'errorPass'" autocomplete="off" placeholder="Enter Email address" style="margin-bottom:35px"></el-input>
          </div>
          <span class="huo">{{bindemail}}</span>
          <!-- <p style="margin-top:15px">Enter Verification Code</p> -->
          <div class="input-box">
            <div class="input-content" @keydown="keydown" @keyup="keyup" @mousewheel="mousewheel"
                @input="inputEvent">
              <el-input style="width: 340px;" oninput="value=value.replace(/\D/gi,'')" type="text" v-model="pasteResult" maxlength="6" placeholder="Enter Verification Code"></el-input>
              <el-button class="borderBtn" @click="countDown()" v-if="maxTotaltime==setTime||setTime==0">Send</el-button>
              <el-button class="borderBtn" v-else>Resend Code (<span>{{setTime}}</span>s)</el-button>
<!--              <input max="9" min="0" maxlength="1" data-index="0" v-model.trim.number="input[0]" type="number"-->
<!--                  ref="firstinput"/>-->
<!--              <input max="9" min="0" maxlength="1" data-index="1" v-model.trim.number="input[1]" type="number"/>-->
<!--              <input max="9" min="0" maxlength="1" data-index="2" v-model.trim.number="input[2]" type="number"/>-->
<!--              <input max="9" min="0" maxlength="1" data-index="3" v-model.trim.number="input[3]" type="number"/>-->
<!--              <input max="9" min="0" maxlength="1" data-index="4" v-model.trim.number="input[4]" type="number"/>-->
<!--              <input max="9" min="0" maxlength="1" data-index="5" v-model.trim.number="input[5]" type="number"/>-->
            </div>
          </div>
          <el-button type="primary" @click="toNext()">Next</el-button>
        </el-form>
        </div>
      </div>
      <!-- 重置密码 -->
      <div class="reset_form" v-else-if="isreset">
        <!-- <p @click="back()"><i class="icon el-icon-arrow-left"></i>Back</p> -->
        <div class="forgetpassgebox">
        <el-form :model="resetForm" :rules="resetValidate" ref="resetForm" label-width="100px" class="demo-resetForm" style="width:100%">
          <h3 class="forgettitle">Reset the Password</h3>
          <p style="margin-top:40px;" class="itemtitle">Enter new password</p>
            <el-form-item prop="newPassword" style="width:100%;">
              <el-input :class="changeFlag == 1?'':'errorPass'" :type="resetForm.newPwdType" v-model="resetForm.newPassword" autocomplete="off" placeholder="Enter new password"></el-input>
              <img :src="resetForm.NewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('NewSeen')">
            </el-form-item>
          <p style="margin-top:40px;" class="itemtitle">Confirm new password</p>
          <el-form-item prop="ConfirmNewPassword" style="width:100%;">
            <el-input :class="changeAgainFlag == 1?'':'errorPass'" :type="resetForm.confirmNewPwdType" v-model="resetForm.ConfirmNewPassword" autocomplete="off" placeholder="Confirm new password"></el-input>
            <img :src="resetForm.confirmNewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('confirmNewSeen')">
          </el-form-item>
          <el-button type="primary" style="width:100%;" @click="toReset()">Save New Password</el-button>
        </el-form>
        </div>
      </div>
      <!-- 注册  -->
      <div class="register_form" v-else-if="isregister">
        <p @click="back()" style="margin-bottom:10px;" class="backbox"><i class="icon el-icon-arrow-left"></i>Back</p>
        <!-- <div class="form_list"> -->
        <div class="forgetpassgebox">
        <el-form style="width:100%" :model="registerruleForm" :rules="signValidate"  ref="registerruleForm" label-width="100px" class="demo-ruleForm">
          <h3 class="logintitle">Register</h3>
          <h4 class="tips">Enter your phone number or email to register.</h4>
          <!-- <p class="itemtitle" style="margin-top:25px;">Phone Number</p> -->
          <el-tabs v-model="activeName" :stretch="true" class="login_tabs" @tab-click="handleClickpe">
            <el-tab-pane label="Phone Number" name="first">
              <div class="phone_form" style="margin-top:15px">
                <el-select v-model="registerruleForm.areaCode" collapse-tags @change="registerchangeCode">
                  <div class="el-input_search">
                    <img src="../assets/search.svg" /><input type="text" placeholder="Search Area Code" class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
                  </div>
                  <el-option v-for="item in areaCodeData"
                    :key="item.id"
                    :label="'+' + item.country_code+' '+item.title "
                    :value="item.id">+{{item.country_code}} {{item.title}}</el-option>
                </el-select>
                <el-form-item prop="phone" class="loginPhone">
                  <el-input style="width:100%" oninput="value=value.replace(/\D/gi,'')" :class="changeLoginFlag == 1?'phone':'errorPass'" class="phone" type="text" v-model="registerruleForm.phone" autocomplete="off" :maxlength="max" placeholder="Enter phone number"></el-input>
                </el-form-item>
              </div>
              <p class="itemtitlelogin" style="margin-top:50px">
                Verification code
              </p>
              <div class="verificationbox">
                <el-input v-model="registerruleForm.yzmcode" placeholder="Enter verification code" style="width:72%"></el-input>
                <el-button class="borderBtn" @click="registercountDown()" v-if="maxTotaltime==setTime||setTime==0">Send</el-button>
                <el-button class="borderBtn" v-else>Resend Code (<span>{{setTime}}</span>s)</el-button>
              </div>
              <p style="margin:10px 0 15px 0">Password</p>
              <div>
              <el-form-item prop="password" class="password">
                <el-input :class="changeFlag == 1?'pass':'errorPass'" :type="registerruleForm.pwdType" v-model="registerruleForm.password" autocomplete="off" placeholder="Please enter your password"></el-input>
               <img :src="registerruleForm.seen?openeye:nopeneye" class="eye" alt="" @click="registechangeType(registerruleForm.seen)">
              </el-form-item>
              </div>
              <div class="login_bottondiv">
                <el-button style="margin-top: 55px !important" type="primary" @click="toRegisteraccount()">register</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Email" name="second">
              <div class="email_form" style="margin:15px 0 15px 0">
                <el-form-item prop="email" class="loginEmail">
                <el-input oninput="value=value.replace(/[^a-zA-Z0-9._%+-@]/gi,'')"  :class="changeLoginFlag == 1?'email':'errorPass'" type="email" v-model="registerruleForm.email" autocomplete="off" placeholder="Enter email address"></el-input>
              </el-form-item>
              </div>
              <p class="itemtitlelogin" style="margin-top:50px">
                Verification code
              </p>
              <div class="verificationbox">
                <el-input v-model="registerruleForm.yzmcode" placeholder="Enter verification code" style="width:72%"></el-input>
                <el-button class="borderBtn" @click="registercountDown()" v-if="maxTotaltime==setTime||setTime==0">Send</el-button>
                <el-button class="borderBtn" v-else>Resend Code (<span>{{setTime}}</span>s)</el-button>
              </div>
              <p style="margin:10px 0 15px 0">Password</p>
              <div>
              <el-form-item prop="password" class="password">
                <el-input :class="changeFlag == 1?'pass':'errorPass'" :type="registerruleForm.pwdType" v-model="registerruleForm.password" autocomplete="off" placeholder="Please enter your password"></el-input>
               <img :src="registerruleForm.seen?openeye:nopeneye" class="eye" alt="" @click="registeremailchangeType(registerruleForm.seen)">
              </el-form-item>
              </div>
              <div class="login_bottondiv">
                <el-button style="margin-top: 55px !important;" type="primary" @click="toRegisteraccount()">register</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        </div>
      </div>
      <!-- savePass -->
      <div class="save_form" v-if="issave">
        <el-form label-width="100px" class="demo-forgetForm">
        <h3 class="forgettitle">New password is saved</h3>
        <p
          class="huo backto"
          @click="back"
          >Back to Sign In page</p>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import store from '@/store/store'
export default {
  name: 'login',
  data () {
    // 手机号验证
    const loginCheck = async (rule, value, callback) => {
      if (this.activeName !== 'first') {
        return callback();
      }
      console.log(rule, value, this.ruleForm.phone, '----------------------------')
      let reg = /^\d{1,}$/
      if (value.length < 1) {
        this.changeLoginFlag = 2
        return callback(new Error('Phone number cannot be empty.'))
      } else if (!reg.test(value)) {
        this.changeLoginFlag = 2
        return callback(new Error('The phone number format is not correct.'))
      // } else if (value.length < 11) {
      //   this.changeLoginFlag = 2
        // return callback(new Error('The phone number cannot be less than 11 digits.'))
      } else {
        this.changeLoginFlag = 1
        callback()
      }
    }
    // 邮箱验证
    const emailCheck = async (rule, value, callback) => {
      if (this.activeName !== 'second') {
        return callback();
      }
      // 邮箱格式正则表达式
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (value.length < 1) {
        this.changeLoginFlag = 2
        return callback(new Error('Email cannot be empty.'))
      } else if (!emailReg.test(value)) {
        this.changeLoginFlag = 2
        return callback(new Error('The email format is not correct.'))
      } else {
        this.changeLoginFlag = 1
        callback()
      }
    }
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      // let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%\*-\+=:,\\?\[\]\{}]).{8,}$/;
      // let reg = /^[0-9a-zA-Z]{8,}$/;
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error('The password cannot be empty.'))
      } else if (value.length < 8) {
        this.changeFlag = 2
        return callback(new Error('The password cannot be less than 8 digits.'))
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error('The password format is not correct.'))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        this.changeAgainFlag = 2
        return callback(new Error('New password cannot be empty.'))
      } else if (this.resetForm.newPassword != this.resetForm.ConfirmNewPassword) {
        this.changeAgainFlag = 2
        return callback(new Error('Both new passwords do not match.'))
      } else {
        this.changeAgainFlag = 1
        callback()
      }
    }
    return {
      methodsvalue:'Phone Number',
      selectmethods:[
        {
          value:'Phone Number',
          label:'Phone Number'
        },{
          value:'Email',
          label:'Email'
        }
      ],
      currentTab: 'password', // 默认显示密码区域
      emailcurrentTab: 'emailpassword', // 默认显示密码区域
      activeName: 'first',
      qvhao: [],
      areaCodeData: [],
      dropDownValue: '',
      valueMeta: [],
      ruleForm: {
        phone: '',
        email: '',
        password: '',
        areaCode: '',
        pwdType: 'password',
        seen: false,
        code: '',
        yzmcode: ''
      },
      registerruleForm:{
        phone: '',
        email: '',
        password: '',
        areaCode: '',
        pwdType: 'password',
        seen: false,
        code: '',
        yzmcode: '',
        time_zone: '',
        confirm_password: ''
      },
      forgetForm: {
        phone: '',
        areaCode: '',
        code:'',
        email:'',
        pwdType: 'password',
      },
      resetForm: {
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        confirmNewSeen: false,
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      signValidate: {
        phone: [
          { required: () => this.activeName === 'first', validator: loginCheck, trigger: 'blur' },
          { min: 6, message: 'Incorrect mobile number format', trigger: 'blur',
            // 只有手机号标签时才生效
            validator: (rule, value, callback) => {
              if (this.activeName === 'first') {
                if (value.length < 6) return callback(new Error('Incorrect mobile number format'));
              }
              callback();
            }
          }
        ],
        password: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ],
        email: [
          { required: () => this.activeName === 'second', validator: emailCheck, trigger: 'blur' },
          { min: 6, message: 'Email cannot be less than 6 characters', trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.activeName === 'second') {
                if (value.length < 6) return callback(new Error('Email cannot be less than 6 characters'));
              }
              callback();
            }
          },
          { max: 64, message: 'Email cannot exceed 64 characters', trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.activeName === 'second') {
                if (value.length > 64) return callback(new Error('Email cannot exceed 64 characters'));
              }
              callback();
            }
          }
        ]
      },
      resetValidate: {
        newPassword: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ],
        ConfirmNewPassword: [
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      changeFlag: 1,
      changeLoginFlag: 1,
      changeAgainFlag: 1,
      openeye: require('@/assets/eye.svg'), // 图片地址
      nopeneye: require('@/assets/eye-off.svg'), // 图片地址
      pasteResult: '', // 存放粘贴进来的数字
      // 验证码倒计时
      maxTotaltime: 60,
      setTime: 60,
      timer: null,
      inputcode: '',
      code: '',
      // 模块判断
      isshow: true,
      isforget: false,
      isregister: false,
      isreset: false,
      issave: false,
      veri: false,
      bindemail: '',
       tishi:'',
       max:10,
       maxforget:10,
       checked:false,//是否保存账号密码
    }
  },

  computed: {
    input () {
      // code 是父组件传进来的默认值，必须是6位长度的数组，这里就不再做容错判断处理
      // 最后空数组是默认值
      // return this.pasteResult.length === 6 ? this.pasteResult : ['', '', '', '', '', '']
      // 页面重构，
      return this.pasteResult.length === 6 ? this.pasteResult.join('') : ''
    }
  },
  watch: {
    'ruleForm.phone': function(newVal, oldVal) {
      if (oldVal && newVal != oldVal && this.currentTab == 'password') {
      this.checked = false;
        this.ruleForm.password = '';
        this.ruleForm.seen = false;
        this.ruleForm.pwdType = 'password';
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate('password');
          }
        })
      }
    },
    'ruleForm.email': function(newVal, oldVal) {
      if (oldVal && newVal != oldVal && this.emailcurrentTab  == 'emailpassword') {
      this.checked = false;
        this.ruleForm.password = '';
        this.ruleForm.seen = false;
        this.ruleForm.pwdType = 'password';
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate('password');
          }
        })
      }
    },
    'registerruleForm.email': function(newVal, oldVal) {
      if (this.activeName == 'second' && oldVal && newVal !== oldVal) {
        this.registerruleForm.yzmcode = '';
        this.registerruleForm.password = '';
        this.registerruleForm.pwdType = 'password';
        this.registerruleForm.seen = false;
        this.$nextTick(() => {
          if (this.$refs.registerruleForm) {
            this.$refs.registerruleForm.clearValidate('password');
          }
        });
      }
    },
    'registerruleForm.phone': function(newVal, oldVal) {
      if (this.activeName == 'first' && oldVal && newVal !== oldVal) {
        this.registerruleForm.yzmcode = '';
        this.registerruleForm.password = '';
        this.registerruleForm.pwdType = 'password';
        this.registerruleForm.seen = false;
        this.$nextTick(() => {
          if (this.$refs.registerruleForm) {
            this.$refs.registerruleForm.clearValidate([
              'password',
              'yzmcode'
            ]);
          }
        });
      }
    }
  },
  created () {
    const savedRememberMe = localStorage.getItem('rememberMe')
    if (savedRememberMe !== null) {
      this.checked = savedRememberMe === 'true'
    }
    if (!this.utils.getCookie('pc_token')) {
      this.$router.push({
        path: '/'
      })
    }
    this.getCountryCode()

    if(localStorage.getItem('phone')&&localStorage.getItem('phone')!=''){
      this.ruleForm.phone =localStorage.getItem('phone')
      this.ruleForm.password=localStorage.getItem('password')
    }
    if(localStorage.getItem('email')&&localStorage.getItem('email')!=''){
      this.ruleForm.email = localStorage.getItem('email')
      this.ruleForm.password = localStorage.getItem('password')
    }
  },
  methods: {
    handleClickpe(){
      if (this.isshow && this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
      if (this.isregister && this.$refs.registerruleForm) {
        this.$refs.registerruleForm.clearValidate();
      }
      // 清除当前定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null; // 重置定时器变量
      }
      this.setTime = this.maxTotaltime;
      this.ruleForm.pwdType = 'password';
      this.ruleForm.seen = false;
      // this.ruleForm.password = '';
      this.registerruleForm.pwdType = 'password';
      this.registerruleForm.seen = false;
      this.registerruleForm.password = '';
      this.registerruleForm.phone = '';
      // this.currentTab = 'password';
      // this.emailcurrentTab = 'emailpassword';
    },
    // 判断是否为APP环境（通常APP会在userAgent中添加特定标识）
    isApp() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      // 假设APP的userAgent包含"myapp"标识，需替换为实际APP的标识
      return userAgent.indexOf('myapp') > -1;
    },
    // 判断是否为PC端（排除移动设备）
    isPC() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const mobileAgents = ['android', 'iphone', 'ipad', 'ipod', 'windows phone'];
      return !mobileAgents.some(agent => userAgent.indexOf(agent) > -1);
    },
    // 手机号注册
    toRegisteraccount(){
      let origin;
      if (this.isApp()) {
        origin = 4; // APP端
      } else if (this.isPC()) {
        origin = 2; // PC端
      } else {
        origin = 2; // 其他设备默认PC
      }
      if(this.activeName=='first'){
        this.$refs.registerruleForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['phone'][0].message)
            return false
          }

          this.$http.post('/tutor/api/mobileRegist', {
            mobile: this.registerruleForm.phone,
            password: this.registerruleForm.password,
            code : this.registerruleForm.yzmcode,
            country_code: this.registerruleForm.code,
            time_zone: this.utils.getTimeZoneCity(),
            confirm_password: this.registerruleForm.password,
            origin: Number(origin)
          }).then((res) => {
            if(res.data.code === 200){
                this.$message({
                  message: res.data.data,
                  type: 'success'
                })
                this.isshow = true
                this.isforget = false
                this.isreset = false
                this.isregister = false
                this.issave = false
                if (this.timer) { // 清除定时器
                  clearInterval(this.timer);
                  this.timer = null; // 重置定时器变量
                }
                this.setTime = this.maxTotaltime;
            }
          }).catch((error) => {
            console.log(error)
          })
        })
      }else{
        this.$refs.registerruleForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['email'][0].message)
            return false
          }

          this.$http.post('/tutor/api/emailRegist', {
            email: this.registerruleForm.email,
            password: this.registerruleForm.password,
            code : this.registerruleForm.yzmcode,
            time_zone: this.utils.getTimeZoneCity(),
            confirm_password: this.registerruleForm.password,
            origin: Number(origin)
          }).then((res) => {
                this.$message({
                  message: res.data.data,
                  type: 'success'
                })
                this.isshow = true
                this.isforget = false
                this.isreset = false
                this.isregister = false
                this.issave = false
                if (this.timer) { // 清除定时器
                  clearInterval(this.timer);
                  this.timer = null; // 重置定时器变量
                }
                this.setTime = this.maxTotaltime;
          }).catch((error) => {
            console.log(error)
          })
        })
      }
    },
    toRegister(){

      this.$nextTick(() => {
        this.registerruleForm.phone = '';
        this.registerruleForm.password = '';
        this.registerruleForm.yzmcode = '';
        this.registerruleForm.seen = false;
        this.registerruleForm.pwdType = 'password';
        this.registerruleForm.email = '';
        if (this.$refs.registerruleForm) {
          this.$refs.registerruleForm.clearValidate();
        }
        this.handleClickpe()
      });
      this.isshow =false
      this.isregister=true
    },
    changeCodeforget(){
      this.areaCodeData.map((item) => {
            if(this.forgetForm.areaCode == item.id){
                this.forgetForm.code = item.country_code
            }
        });
        if(this.forgetForm.code=='86'){
			if(this.forgetForm.phone.length>11){
				this.forgetForm.phone = ''
			}
          this.maxforget = 11
		  // this.signValidate.phone[1].min = 1
        }else if(this.forgetForm.code=='1'){
          if(this.forgetForm.phone.length>10){
            this.forgetForm.phone = ''
          }
          this.maxforget = 10
		//  this.signValidate.phone[1].min = 1
        }else{
			// this.signValidate.phone[1].min = 6
			this.maxforget= 15
		}
    },
    registerchangeCode(){
        this.areaCodeData.map((item) => {
            if(this.registerruleForm.areaCode == item.id){
                this.registerruleForm.code = item.country_code
            }
        });
        if(this.registerruleForm.code === '86'){
			if(this.registerruleForm.phone.length > 11){
				this.registerruleForm.phone = ''
			}
          this.max = 11
        } else if(this.registerruleForm.code === '1'){
          if(this.registerruleForm.phone.length > 10){
            this.registerruleForm.phone = ''
          }
          this.max = 10
		//  this.signValidate.phone[1].min = 1
        }else{
			// this.signValidate.phone[1].min = 6
			this.max= 15
		}
      },
    changeCode(){
        this.areaCodeData.map((item) => {
            if(this.ruleForm.areaCode == item.id){
                this.ruleForm.code = item.country_code
            }
        });
        if(this.ruleForm.code=='86'){
			if(this.ruleForm.phone.length>11){
				this.ruleForm.phone = ''
			}
          this.max = 11
		  // this.signValidate.phone[1].min = 1
        }else if(this.ruleForm.code=='1'){
          if(this.ruleForm.phone.length>10){
            this.ruleForm.phone = ''
          }
          this.max = 10
		//  this.signValidate.phone[1].min = 1
        }else{
			// this.signValidate.phone[1].min = 6
			this.max= 15
		}
      },
    dropDownSearch () {
      var _this = this
      if (_this.dropDownValue) {
        _this.areaCodeData = []
        _this.qvhao.find(item => {
          let name =  ' +' + item.country_code  +item.title
          if (name.indexOf(_this.dropDownValue) != -1) {
            _this.areaCodeData.push(item)
          }
        })
      } else {
        _this.areaCodeData = _this.qvhao
      }
    },
    changeType (seen) {
      // 处理密码显示/隐藏
      if (seen === 'NewSeen') {
        this.resetForm.newPwdType = this.resetForm.newPwdType === 'password' ? 'text' : 'password'
        this.resetForm.NewSeen = !this.resetForm.NewSeen
      } else if (seen == 'confirmNewSeen') {
        this.resetForm.confirmNewPwdType = this.resetForm.confirmNewPwdType === 'password' ? 'text' : 'password'
        this.resetForm.confirmNewSeen = !this.resetForm.confirmNewSeen
      } else {
        this.ruleForm.pwdType = this.ruleForm.pwdType === 'password' ? 'text' : 'password'
        this.ruleForm.seen = !seen
      }
    },
    // 手机号注册密码隐藏眼睛
    registechangeType (seen) {
      this.registerruleForm.pwdType = this.registerruleForm.pwdType === 'password' ? 'text' : 'password'
      this.registerruleForm.seen = !seen
    },
    // 邮箱注册密码隐藏眼睛
    registeremailchangeType (seen) {
      this.registerruleForm.pwdType = this.registerruleForm.pwdType === 'password' ? 'text' : 'password'
      this.registerruleForm.seen = !seen
    },
    // 邮箱登录密码隐藏眼睛
    emailchangeType (seen) {
      this.ruleForm.pwdType = this.ruleForm.pwdType === 'password' ? 'text' : 'password'
      this.ruleForm.seen = !seen
    },
    back () {
      this.handleClickpe()
      this.isshow = true
      this.isforget = false
      this.isreset = false
      this.isregister = false
      this.issave = false
      Object.assign(this.$data.forgetForm, this.$options.data().forgetForm)
      this.pasteResult = ''
      this.veri = false

        clearInterval(this.timer)
        this.timer = null
        this.setTime = 60
      this.areaCodeData = store.getAreaCode()
      this.forgetForm.areaCode=this.areaCodeData[0].id
        this.forgetForm.code=this.areaCodeData[0].country_code
        this.registerruleForm.phone = '';
        this.registerruleForm.password = '';
        this.registerruleForm.yzmcode = '';
    },
    forgetPass () {
      this.handleClickpe()
      this.isshow = !this.isshow
      this.isforget = !this.isforget
    },
    toNext () {
      if(this.methodsvalue === 'Phone Number'){
        this.$refs.forgetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['phone'][0].message)
            return false
          }

          if (this.veri) {
            this.$http.post('/tutor/api/verifyCodeToEmail', {
              mobile: this.forgetForm.phone,
              code: this.pasteResult,
              country_code: this.forgetForm.code
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                this.isforget = !this.isforget
                this.isreset = !this.isreset
                store.setUser(res.data.data)
                this.utils.setCookies({
                  pc_token: res.data.data.token
                })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          } else {
            this.$http.post('/tutor/api/verifyCode', {
              mobile: this.forgetForm.phone,
              code: this.pasteResult,
              country_code: this.forgetForm.code
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                this.isforget = !this.isforget
                this.isreset = !this.isreset
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        })
      } else {
        this.$refs.forgetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['email'][0].message)
            return false
          }

          this.$http.post('/tutor/api/emailCodeVerify', {
            email: this.forgetForm.email,
            code: this.pasteResult,
          }).then((res) => {
            if (res.data.code == 200) {
              console.log(res)
              this.isforget = !this.isforget
              this.isreset = !this.isreset
              store.setUser(res.data.data)
              this.utils.setCookies({
                pc_token: res.data.data.token
              })
              // this.$router.push({ path: '/index' })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })

      })
      }

    },
    // 登录
    submitForm () {
      if(this.activeName=='first'){
        if(this.currentTab == 'password'){
          this.$refs.ruleForm.validate((valid, msg) => {
            if (!valid) {
              this.$message(msg['phone'][0].message || msg['password'][0].message)
              return false
            }

            this.$http.post('/tutor/api/login', {
              mobile: this.ruleForm.phone,
              password: this.ruleForm.password,
              country_code: this.ruleForm.code,
              time_zone: this.utils.getTimeZoneCity()
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                store.setUser(res.data.data)
                this.utils.setCookies({
                  pc_token: res.data.data.access_token
                })

                if(this.checked === true){
                  //存储账号密码到缓存
                  localStorage.setItem('phone', this.ruleForm.phone)
                  localStorage.setItem('password', this.ruleForm.password)
                  localStorage.setItem('areaCode', this.ruleForm.areaCode)
                  localStorage.setItem('rememberMe', this.checked);
                } else {
                  localStorage.removeItem('phone');
                  localStorage.removeItem('password');
                  localStorage.removeItem('areaCode');
                  localStorage.removeItem('rememberMe');
                }

                this.$router.push({ path: '/index' })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          })
        } else {
          this.$refs.ruleForm.validate((valid, msg) => {
            // if (!valid) {
            //   this.$message(msg['phone'][0].message)
            //   return false
            // }

            this.$http.post('/tutor/api/loginMobileCode', {
              mobile: this.ruleForm.phone,
              code: this.ruleForm.yzmcode,
              country_code: this.ruleForm.code,
              time_zone: this.utils.getTimeZoneCity()
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                store.setUser(res.data.data)
                this.utils.setCookies({
                  pc_token: res.data.data.access_token
                })

                if(this.checked === true){
                  localStorage.setItem('phone', this.ruleForm.phone)
                  localStorage.setItem('password', this.ruleForm.password)
                  localStorage.setItem('areaCode', this.ruleForm.areaCode)
                  localStorage.setItem('rememberMe', this.checked);
                } else {
                  localStorage.removeItem('phone');
                  localStorage.removeItem('password');
                  localStorage.removeItem('areaCode');
                  localStorage.removeItem('rememberMe');
                }

                this.$router.push({ path: '/index' })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          })
        }
      }else{
        this.$refs.ruleForm.validate((valid, msg) => {
          // if (!valid) {
          //   this.$message(msg['email'][0].message || msg['password'][0].message)
          //   return false
          // }

          if(this.emailcurrentTab === 'emailpassword'){
            this.$http.post('/tutor/api/loginEmailPass', {
              email: this.ruleForm.email,
              password: this.ruleForm.password,
              time_zone: this.utils.getTimeZoneCity()
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                store.setUser(res.data.data)
                this.utils.setCookies({
                  pc_token: res.data.data.access_token
                })

                if(this.checked === true){
                  localStorage.setItem('email', this.ruleForm.email)
                  localStorage.setItem('password', this.ruleForm.password)
                  localStorage.setItem('rememberMe', this.checked);
                } else {
                  localStorage.removeItem('email');
                  localStorage.removeItem('password');
                  localStorage.removeItem('rememberMe');
                }

                this.$router.push({ path: '/index' })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          } else {
            this.$http.post('/tutor/api/loginEmailCode', {
              email: this.ruleForm.email,
              code: this.ruleForm.yzmcode,
              time_zone: this.utils.getTimeZoneCity()
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                store.setUser(res.data.data)
                this.utils.setCookies({
                  pc_token: res.data.data.access_token
                })

                if(this.checked === true){
                  localStorage.setItem('email', this.ruleForm.email)
                  localStorage.setItem('password', this.ruleForm.password)
                  localStorage.setItem('rememberMe', this.checked);
                } else {
                  localStorage.removeItem('email');
                  localStorage.removeItem('password');
                  localStorage.removeItem('rememberMe');
                }

                this.$router.push({ path: '/index' })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          }

        })
      }

      // let data = {
      //   mobile:this.ruleForm.phone,
      //   password:this.ruleForm.password,
      //   country_code:this.ruleForm.areaCode
      // }
      // // ?mobile="+this.ruleForm.phone+"&password="+this.ruleForm.password+"&country_code="+this.ruleForm.areaCode
      // this.$http
      // .post("/tutor/api/login",JSON.stringify(data))
      // .then((res) => {
      //   console.log(res.data.data.sn);
      //   this.sn = res.data.sn;
      // });
    },
    toReset () {
      if(this.methodsvalue === 'Phone Number'){
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }

          if (this.veri) {
            this.$http.post('/tutor/api/setPassword', {
              access_token: store.getUser().access_token,
              password: this.resetForm.newPassword
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                this.issave = !this.issave
                this.isreset = !this.isreset
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          } else {
            this.$http.post('/tutor/api/forgotPassword', {
              mobile: this.forgetForm.phone,
              newPassword: this.resetForm.newPassword,
              repeatPassword: this.resetForm.ConfirmNewPassword
            }).then((res) => {
              if (res.data.code === 200) {
                console.log(res)
                this.issave = !this.issave
                this.isreset = !this.isreset
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.forgetForm.phone='',
                this.resetForm.newPassword='',
                this.resetForm.ConfirmNewPassword=''
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        })
      } else {
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }

          this.$http.post('/tutor/api/forgotPassEmail', {
            email: this.forgetForm.email,
            newPassword: this.resetForm.newPassword,
            repeatPassword: this.resetForm.ConfirmNewPassword
          }).then((res) => {
            if (res.data.code == 200) {
              console.log(res)
              this.issave = !this.issave
              this.isreset = !this.isreset
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
              this.forgetForm.email='',
              this.resetForm.newPassword='',
              this.resetForm.ConfirmNewPassword=''
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })

      })
      }

    },
    // 国家区号
    getCountryCode () {
      this.$http.get('/api/dict/countries?page=1&pagesize=999&keywords=&country_code=').then((res) => {
        console.log(res)
        this.qvhao = res.data.data
        this.areaCodeData = res.data.data
        store.setAreaCode(res.data.data)
        this.ruleForm.areaCode=this.areaCodeData[0].id
        this.ruleForm.code=this.areaCodeData[0].country_code

        this.forgetForm.areaCode=this.areaCodeData[0].id
        this.forgetForm.code=this.areaCodeData[0].country_code

        this.registerruleForm.areaCode=this.areaCodeData[0].id
        this.registerruleForm.code=this.areaCodeData[0].country_code

        //是否保存账号密码
        if(localStorage.getItem('phone') && localStorage.getItem('phone') !== ''){
          this.ruleForm.areaCode = Number(localStorage.getItem('areaCode'))
          this.changeCode()
        }
      })
    },
    // 倒计时
    setCount (setTime) {
      if (setTime >= 0) {
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.setTime > 0 && this.setTime <= this.maxTotaltime) {
              this.setTime--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.setTime = 60
            }
          }, 1000)
        }
      }
    },
    countDown () {
      if(this.methodsvalue=='Phone Number'){
        if (!this.forgetForm.phone) {
          this.$message({
            message: 'Phone number cannot be empty.',
            type: 'warning'
          })
          return false
        }
        if (this.maxTotaltime == this.setTime) {
          this.setCount(this.setTime)
          if (this.changeLoginFlag == 1) {
            if (this.veri) {
              this.$http.post('/tutor/api/getEmail', {
                mobile: this.forgetForm.phone,
                country_code: this.forgetForm.code
              }).then((res) => {
                if (res.data.code == 200) {
                  console.log(res)
                  if (res.data.data.email) {
                    this.sendEmail()
                  }
                  this.bindemail = res.data.data.email
                  // store.setUser(res.data.data);
                  // this.$router.push({ path: "/index" });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              }).catch((error) => {
                console.log(error) // 请求失败返回的数据
              })
            } else {
              this.$http.post('/api/login/verify-code', {
                mobile: this.forgetForm.phone,
                length: 6,
                country_code: this.forgetForm.code
              }).then((res) => {
                if (res.data.code == 200) {
                  console.log(res)
                  this.code = res.data.data.code
                  // store.setUser(res.data.data);
                  // this.$router.push({ path: "/index" });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              }).catch((error) => {
                console.log(error) // 请求失败返回的数据
              })
            }
          }
          // if (this.phone) {
          //  var sendPhone=this.phone
          // }
          // // 发送验证码的ajax
          // Ajax({
          // 		method: 'GET',
          // 		url: 'login/sendSMS',
          // 		data: {
          // 			phone:sendPhone,
          // 			templateType:1,
          // 			dealType:1,
          // 		},
          // 		success: function(ret){
          // 				if (ret.code == 1) {

          // 				}else{
          // 					mineAlert(ret.msg)
          // 				}
          // 		}
          // });
        }
      }else{
        if (!this.forgetForm.email) {
          this.$message({
            message: 'Email cannot be empty.',
            type: 'warning'
          })
          return false
        }
        if (this.maxTotaltime == this.setTime) {
              this.setCount(this.setTime)
              this.$http.post('/tutor/api/sendEmailCode', {
                email: this.forgetForm.email,
              }).then((res) => {
                if (res.data.code == 200) {
                  console.log(res)
                  if (res.data.data.email) {
                    this.sendEmail()
                  }
                  this.bindemail = res.data.data.email
                  // store.setUser(res.data.data);
                  // this.$router.push({ path: "/index" });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              }).catch((error) => {
                console.log(error) // 请求失败返回的数据
              })

        }
      }

    },
    registercountDown () {
      if(this.activeName=='first'){
        if (!this.registerruleForm.phone) {
          this.$message({
            message: 'Phone number cannot be empty.',
            type: 'warning'
          })
          return false
        }
      } else {
        if (!this.registerruleForm.email) {
          this.$message({
            message: 'Email cannot be empty.',
            type: 'warning'
          })
          return false
        }
      }
      if (this.maxTotaltime == this.setTime) {
        this.setCount(this.setTime)
        if (this.activeName=='second') {
            this.$http.post('/tutor/api/sendEmailCode', {
              email: this.registerruleForm.email,
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                if (res.data.data.email) {
                  this.sendEmail()
                }
                this.bindemail = res.data.data.email
                // store.setUser(res.data.data);
                // this.$router.push({ path: "/index" });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
        } else {
            this.$http.post('/api/login/verify-code', {
              mobile: this.registerruleForm.phone,
              length: 6,
              country_code: this.registerruleForm.code
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.code = res.data.data.code
                // store.setUser(res.data.data);
                // this.$router.push({ path: "/index" });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
        }
      }
    },
    logincountDown () {
      if(this.activeName=='first'){
        if (!this.ruleForm.phone) {
          this.$message({
            message: 'Phone number cannot be empty.',
            type: 'warning'
          })
          return false
        }
      } else {
        if (!this.ruleForm.email) {
          this.$message({
            message: 'Email cannot be empty.',
            type: 'warning'
          })
          return false
        }
      }
      if (this.maxTotaltime == this.setTime) {
        this.setCount(this.setTime)
        if (this.activeName=='second') {
            this.$http.post('/tutor/api/sendEmailCode', {
              email: this.ruleForm.email,
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                if (res.data.data.email) {
                  this.sendEmail()
                }
                this.bindemail = res.data.data.email
                // store.setUser(res.data.data);
                // this.$router.push({ path: "/index" });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
        } else {
            this.$http.post('/api/login/verify-code', {
              mobile: this.ruleForm.phone,
              length: 6,
              country_code: this.ruleForm.code
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.code = res.data.data.code
                // store.setUser(res.data.data);
                // this.$router.push({ path: "/index" });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
        }
      }
    },
    sendEmail () {
      this.$http.post('/tutor/api/sendCodeToEmail', {
        mobile: this.forgetForm.phone,
        country_code: this.forgetForm.areaCode
      }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res)
          // this.email = res.data.data.email
          // store.setUser(res.data.data);
          // this.$router.push({ path: "/index" });
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    // 验证码
    // 解决一个输入框输入多个字符
    inputEvent (e) {
      var index = e.target.dataset.index * 1
      var el = e.target
      this.$set(this.input, index, el.value.slice(0, 1))
    },
    keydown (e) {
      var index = e.target.dataset.index * 1
      var el = e.target
      if (e.key === 'Backspace') {
        if (this.input[index].length > 0) {
          this.$set(this.input, index, '')
        } else {
          if (el.previousElementSibling) {
            el.previousElementSibling.focus()
            this.$set(this.input, index - 1, '')
          }
        }
      } else if (e.key === 'Delete') {
        if (this.input[index].length > 0) {
          this.$set(this.input, index, '')
        } else {
          if (el.nextElementSibling) {
            this.$set(this.input, index = 1, '')
          }
        }
        if (el.nextElementSibling) {
          el.nextElementSibling.focus()
        }
      } else if (e.key === 'Home') {
        el.parentElement.children[0] && el.parentElement.children[0].focus()
      } else if (e.key === 'End') {
        el.parentElement.children[this.input.length - 1] && el.parentElement.children[this.input.length - 1].focus()
      } else if (e.key === 'ArrowLeft') {
        if (el.previousElementSibling) {
          el.previousElementSibling.focus()
        }
      } else if (e.key === 'ArrowRight') {
        if (el.nextElementSibling) {
          el.nextElementSibling.focus()
        }
      } else if (e.key === 'ArrowUp') {
        if (this.input[index] * 1 < 9) {
          this.$set(this.input, index, (this.input[index] * 1 + 1).toString())
        }
      } else if (e.key === 'ArrowDown') {
        if (this.input[index] * 1 > 0) {
          this.$set(this.input, index, (this.input[index] * 1 - 1).toString())
        }
      }
    },
    keyup (e) {
      var index = e.target.dataset.index * 1
      var el = e.target
      if (/Digit|Numpad/i.test(e.code)) {
        this.$set(this.input, index, e.code.replace(/Digit|Numpad/i, ''))
        el.nextElementSibling && el.nextElementSibling.focus()
        if (index === 5) {
          if (this.input.join('').length === 6) {
            document.activeElement.blur()
            // this.$emit('complete', this.input);
          }
        }
      } else {
        if (this.input[index] === '') {
          this.$set(this.input, index, '')
        }
      }
    },
    mousewheel (e) {
      var index = e.target.dataset.index
      if (e.wheelDelta > 0) {
        if (this.input[index] * 1 < 9) {
          this.$set(this.input, index, (this.input[index] * 1 + 1).toString())
        }
      } else if (e.wheelDelta < 0) {
        if (this.input[index] * 1 > 0) {
          this.$set(this.input, index, (this.input[index] * 1 - 1).toString())
        }
      } else if (e.key === 'Enter') {
        if (this.input.join('').length === 6) {
          document.activeElement.blur()
          // this.$emit('complete', this.input);
        }
      }
    },
    paste (e) {
      // 当进行粘贴时  @paste="paste"
      e.clipboardData.items[0].getAsString(str => {
        if (str.toString().length === 6) {
          this.pasteResult = str.split('')
          document.activeElement.blur()
          // this.$emit('complete', this.input);
        }
      })
    }
  },

  mounted () {
    this.handleClickpe()
    // 等待dom渲染完成，在执行focus,否则无法获取到焦点
    // this.$nextTick(() => {
    //   this.$refs.firstinput.focus()
    // })
     var userAgent =navigator.userAgent;
      var Chrome=userAgent.indexOf('Chrome') > -1;
      var Edge =userAgent.indexOf('Edg')>-1;

      if(!(Chrome||Edge)){
        this.tishi='Please make sure you use Google Chrome or Microsoft Edge browser.';
      }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
  }
  .indexhome{
    width: 100%;
    font-family: Arial;
    font-weight: 400;
  }
  .el-header{
      margin: 0 auto;
      height:64px !important;
      background-color: #FF904D;
      font-family: Arial;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      line-height: 64px;
      padding-left: 24px;
      width: 100%;
      img{
        margin: 5.5px 0;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    background-image: url("../assets/border1@1x.png");
    background-position: bottom;
    height: calc(100vh - 64px);
    background-repeat: repeat-x;
    background-color: #FFF8D0;

    .logintitle{
      font-size: 36px;
      font-family: Arial;
      font-weight: 700;
      color: #353643;
      margin-top:10px;
    }
    .tips{
      font-size: 16px;
      font-family: Arial;
      font-weight: normal;
      color: #666666;
      margin-top:18px;
      line-height: 24px;
    }
    .tipss{
      font-size: 14px;
      line-height: 24px;
      font-family: Arial;
      margin-top:6px;
      color: #999999;
    }
    .itemtitle{
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 8px;
    }
    .register_form{
        margin-left: 0px;
        margin-top:28px;
        height: 90%;
        .backbox{
          color: #FF6E17;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          cursor: pointer;
        }
    }
    .login_form{
      background-color: #fff;
      border-radius: 16px;
      box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1),0px 10px 15px -3px rgba(0, 0, 0, 0.1);
      width: 23%;
      height: 544px;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 40px;
    }
    .el-form {
        width: 340px;
        display: flex;
        flex-direction: column;
        p{
          span{
            cursor: pointer;
          }
        }
        .phone_form{
          display: flex;
          flex-direction: row;
          margin-bottom: 22px;
          width:100%;
          height: 50px;
          .el-select {
            width: 148px;
            height: 40px;
            // background: #fafafa;
            border:none;
            color: #353643;
            border-radius: 8px 0px 0px 8px;
            border: 1px solid #E5E7EB;
            /deep/ .el-input{
              height:40px;
              .el-input__inner{
                width:120px;
                //height: 100%;
                background: none;
                border:none;
                color: #353643;
                font-family: Arial;
              }
              .el-input__suffix{
                right: 15px;
              }
              .el-select__caret{
                color: #6e6b7b;
              }
            }
          }
          .phone{
            width:255px;
            //padding-left:10px;
            border:none;
            background: none;
            font-size: 16px;
            //border-bottom: 1px solid #a5a5a5;
            color: #353643;
            font-family: Arial;
            letter-spacing: 0px;
          }
        }
        .email_form{
          .loginEmail{
            width: 100%;
            /deep/.el-form-item__content{
              border-width: 1px 1px 1px 1px !important;
              border-radius: 8px 8px 8px 8px !important;
            }
          }
          /deep/.email .el-input__inner{
            height: 40px !important;
            border-radius: 8px !important;
            padding: 12px 16px;
          }
        }
        /deep/ .el-form-item{
            .el-form-item__content{
              border-radius: 2px 8px 8px 2px;
              border-width: 1px 1px 1px 0px;
              border-style: solid;
              border-color: #E5E7EB;
              display: flex;
              margin:0!important;
              img{
                position: absolute;
                width: 20px;
                height:20px;
                margin: 0 8px;
                right: 0px;
                bottom:12px;
              }
              .el-input{
                //border-bottom: 1px solid #a5a5a5;
              }
              .errorPass{
                //border-bottom: 1px solid #fc424c;
                border-bottom: none;
              }
              .el-input__inner {
                -moz-appearance: none;
                //width:100%;
                height: 40px;
                border:none;
                background: none;
                font-size: 12px;
                color: #353643;
                font-family: Arial;
                letter-spacing: 0px;
                outline: 0;
                border-radius: 0;
                background-color: #FFFFFF !important;
              }
              .el-input__inner::placeholder{
                color: #999999;
                font-family: Arial;
                font-size: 12px;
                font-weight: normal;
                line-height: 24px;
                letter-spacing: 0px;
                display: inline-block;
                margin-left: 16px;
              }
              .el-form-item__error{
                // margin-top:7px;
                font-size: 16px;
                font-weight: normal;
                line-height: 24px;
                color: #FF0000;
                font-family: Arial;
                width: 100%;
                left: 0;
                margin-left: 0px !important;
              }
            }
        }
        /deep/ .password{
          width: 100%;
          .el-form-item__content{
            border: none;
            border-radius:unset;
          }
          .el-input__inner{
            width: 100% !important;
            height: 50px !important;
            border-radius: 8px !important;
            padding: 12px 16px;
            background: #FFFFFF;
            box-sizing: border-box;
            border: 1px solid #E5E7EB !important;
          }
        }
        /deep/ .loginPhone{
          width: 330px;
          .el-form-item__error{
            left: -120px !important;
          }
        }

        .huo {
          font-size: 16px;
          font-family: Arial;
          text-decoration: none !important;
          text-align: LEFT;
          color: #FF904D;
          cursor: pointer;
          margin-top:40px;
          display: contents;
        }
        button{
          //width: 190px;
          height: 40px;
          background: #FF904D;
          border-radius: 4px;
          border: 1px solid #FF904D;
          margin-top: 32px;
          color: #fff;
          font-size: 16px;
          font-family: Arial;
        }
        .borderBtn{
            width:auto;
            height: 40px;
            background: #ffffff;
            border: 1px solid #FF6E17;
            border-radius: 8px;
            font-size: 16px;
            font-family: Arial;
            color: #FF6E17;
            margin: 0 20px;
            &:hover{
              background: #ffffff;
              border: 1px solid #FF6E17;
              font-size: 16px;
              font-family: Arial;
              color: #FF6E17;
            }
        }
        p{
          // margin-top:15px;
        }
        input{
          width:345px;
          height: 50px;
          border:none;
          background: none;
          font-size: 18px;
          color: #353643;
          font-family: Arial;
          letter-spacing: 0px;
        }
        input:focus {
          outline: none;
        }
      }
      .forgot_form{
        margin-left: 0px;
        margin-top:28px;
        height: 90%;
        .backbox{
          color: #FF6E17;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          cursor: pointer;
        }
        .forgettitle{
          margin-bottom:42px;
          margin-top: 32px;
          font-family: Arial;
          font-size: 36px;
          font-weight: bold;
          line-height: 36px;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #333333;
        }
        /deep/.phone_form{
          display: flex;
          flex-direction: row;
          margin-bottom: 22px;
          width: 100%;
          height: 50px;
          .el-select {
            width: 148px;
            height: 40px;
            // background: #fafafa;
            border:none;
            color: #353643;
            border-radius: 8px 0px 0px 8px;
            border: 1px solid #E5E7EB;
            /deep/ .el-input{
              height:40px;
              .el-input__inner{
                width:120px;
                //height: 100%;
                background: none;
                border:none;
                color: #353643;
                font-family: Arial;
              }
              .el-input__suffix{
                right: 15px;
              }
              .el-select__caret{
                color: #6e6b7b;
              }
            }
          }
          .phone{
            width:255px;
            //padding-left:10px;
            border:none;
            background: none;
            font-size: 16px;
            //border-bottom: 1px solid #a5a5a5;
            color: #353643;
            font-family: Arial;
            letter-spacing: 0px;
          }
        }
        /deep/ .el-form-item{
          .el-form-item__content{
            border-radius: 2px 8px 8px 2px;
            border-width: 1px 1px 1px 0px;
            border-style: solid;
            border-color: #E5E7EB;
            display: flex;
            margin:0!important;
            img{
              position: absolute;
              width: 20px;
              height:20px;
              margin: 0 8px;
              right: 0px;
              bottom:12px;
            }
            .el-input{
              //border-bottom: 1px solid #a5a5a5;
            }
            .errorPass{
              width: 100%;
              //border-bottom: 1px solid #fc424c;
              border-bottom: none;
            }
            .el-input__inner {
              -moz-appearance: none;
              width:100%;
              height: 40px;
              border:none;
              background: none;
              font-size: 12px;
              color: #353643;
              font-family: Arial;
              letter-spacing: 0px;
              outline: 0;
              border-radius: 0;
              background-color: #FFFFFF !important;
            }
            .el-input__inner::placeholder{
              color: #999999;
              font-family: Arial;
              font-size: 12px;
              font-weight: normal;
              line-height: 24px;
              letter-spacing: 0px;
              display: inline-block;
              margin-left: 16px;
            }
            .el-form-item__error{
              // margin-top:7px;
              font-size: 16px;
              font-weight: normal;
              line-height: 24px;
              color: #FF0000;
              font-family: Arial;
              width: max-content;
              left: -120px;
              //left: 0;
            }
          }
        }
        .input-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .input-content {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            input {
              color: inherit;
              font-family: Arial;
              border: 0;
              outline: 0;
              border-bottom: 1px solid #a5a5a5;
              height: 50px;
              width: 40px;
              font-size: 28px;
              text-align: center;
            }
          }

          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            appearance: none;
            margin: 0;
          }
        }
      }
      .reset_form{
        margin-left: 80px;
        margin-top: 34px;
        width:auto;
        height: 90%;
        .el-form{
          width: auto;
        }
          .el-form-item{
            width:385px;
          }
        .forgettitle{
          margin-bottom:42px;
          margin-top: 32px;
          font-family: Arial;
          font-size: 36px;
          font-weight: bold;
          line-height: 36px;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #333333;
        }
      }
    .save_form{
      margin-left: 80px;
      margin-top: 34px;
      width:auto;
      .el-form{
        width: auto;
      }
      .forgettitle{
        margin-bottom:42px;
        margin-top: 32px;
        font-family: Arial;
        font-size: 36px;
        font-weight: bold;
        line-height: 36px;
        letter-spacing: 0px;
        font-variation-settings: "opsz" auto;
        color: #333333;
      }
      .backto{
        font-family: Arial;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: 0px;
        text-decoration: underline;

        font-variation-settings: "opsz" auto;
        color: #FF6E17;
        margin-top:30px;display:inline-block;
      }
    }
  }
.index_tishi{
  font-family: Arial;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  margin-top: 32px;
}

.rendme{
  // margin-top: 20px;
}
.rebox{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 44px;
}
  /deep/.el-form-item{
    margin-bottom: 0 !important;
  }
  .eye{
    position: absolute;
  }
  /deep/.login_tabs{
    margin-top: 20px;
    .el-tabs__item.is-active{
      color:#FF904D
    }
    .el-tabs__active-bar{
      background-color:#FF904D
    }
  }
  .login_bottondiv{
    width: 100%;

    button{
      width: 100%;
    }
    .createaccount_button{
      margin-left: 0 !important;
      background:#fff !important;
      color: #FF904D !important;
      margin-top: 10px !important;
      border: none !important;
    }
  }
  .itemtitlelogin{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .itemtitlelogin span.active {
  color: #FF904D;
  font-weight: bold;
}
.verificationbox{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button{
    margin-top: 0 !important;
  }
}
.forgetpassgebox{
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1),0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    width: 23%;
    height: 538px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
}
/deep/ .selectphonetext .el-input__inner{
  color: #FF904D;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue